module.exports = (__webpack_require__(85))(3);